import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Form,
  Menu,
  Icon,
  Button,
  Loader,
  Image,
  Divider,
  Header,
  Modal,
  Radio,
  Checkbox,
  Segment,
} from "semantic-ui-react";
import {
  Container,
  Title,
  Field,
  Label,
  InputFile,
  InputText,
  InputLabel,
} from "../../../../../pages/Admin/Empresas/criarEmpresas/styled";

import Dropzone from "../../../../../components/Admin/Dropzone";
import { voittoapi as api } from "../../../../../services/apis";
import swal from "sweetalert";

const Informacoes = (props) => {
  const [selectedFile, setSelectedFile] = useState("");

  const [empresa, setEmpresa] = useState({
    nome: props.valor.nome,
    logo: props.valor.logo,
    url: props.valor.url,
    file: "",
  });

  const handleValue = useCallback(() => {
    props.handleInfo(empresa);
  }, [empresa]);

  const handleSelectedFile = useCallback(
    (file) => {
      setEmpresa((empresa) => ({ ...empresa, file }));
    },
    [empresa]
  );

  return (
    <>
      <Field>
        <Label>Nome da Empresa</Label>
        <InputText
          type="text"
          placeholder="Nome da empresa"
          value={empresa.nome}
          onChange={(e) => setEmpresa({ ...empresa, nome: e.target.value })}
        />
      </Field>

      <Field>
        <Label>Logo da empresa</Label>
        <Dropzone onFileUploaded={handleSelectedFile} />
      </Field>
      <Field>
        <Divider hidden />
        <Image src={empresa.logo} size="medium" />
        <Divider hidden />
      </Field>
      <Field>
        <Label>Url do Portal</Label>
        <InputLabel
          label="https://www.voitto.com.br/online/"
          placeholder="portal-..."
          value={empresa.url}
          onChange={(e) => setEmpresa({ ...empresa, url: e.target.value })}
        />
      </Field>
      <Field>
        <Button type="submit" onClick={handleValue}>
          <Icon name="save" />
          Salvar Informações
        </Button>
      </Field>
    </>
  );
};

export default Informacoes;
